// extracted by mini-css-extract-plugin
export default {"button":"payment-button_button__14dbc"};